import angular from 'angular';
import analyticsCustomReports from '../Components/analyticsCustomReports/analyticsCustomReports.component';

export default angular
    .module('app.analytics.analyticsCustomReports', [])
    .component("analyticsCustomReports", analyticsCustomReports)
    .name;